import React from "react";
import { RouterProvider } from "react-router-dom";
import AppProviders from "./providers/AppProviders";
import { appRouter } from "./router/router";
import { useAuthStore } from "../core/store/auth.store";

const AppShell: React.FC = () => {
  React.useEffect(() => {
    const { user, token, refreshtoken, isAuthenticated } = useAuthStore.getState();
    // console.log("[DEBUG] Sesión actual al cargar la app:", { user, token, refreshtoken, isAuthenticated });
  }, []);

  return (
    <AppProviders>
      <RouterProvider router={appRouter} />
    </AppProviders>
  );
};

export default AppShell;
